<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">

			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="refForm" :model="modalInfo"
			 :label-width="90">
			<!--放置不需要添加的属性 -->
				<Row v-show="false" :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$tt('控件名称')" prop="Name">
						<Input :disabled="modal.canInput" v-model="modalInfo.Name" :placeholder="$tt('控件名称')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('显示名称')" prop="Display">
						<Input :disabled="modal.canInput" v-model="modalInfo.Display" :placeholder="$tt('显示名称')"></Input>
					</FormItem>
					</Col>
				</Row>
				
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$tt('控件名称')" prop="Name">
						<Input :disabled="modal.canInput" v-model="modalInfo.Name" :placeholder="$tt('控件名称')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('显示名称')" prop="Display">
						<Input :disabled="modal.canInput" v-model="modalInfo.Display" :placeholder="$tt('显示名称')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$tt('控件描述')" prop="Desc">
						<Input :disabled="modal.canInput" v-model="modalInfo.Desc" :placeholder="$tt('控件描述')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('控件图标')" prop="Icon">
						<Input :disabled="modal.canInput" v-model="modalInfo.Icon" :placeholder="$tt('控件图标')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="$tt('是否删除')" prop="IsDeleted">
						<Input :disabled="modal.canInput" v-model="modalInfo.IsDeleted" :placeholder="$tt('是否删除')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('控件类型')" prop="WidgetType">
						<Select :disabled="modal.WidgetType" :placeholder="$tt('控件类型')" v-model="modalInfo.Status">
							<Option :value='1'>buttons</Option>
							<Option :value='2'>tableBar</Option>
							<Option :value='3'>form</Option>

						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="$tt('是否为警告操作')" prop="IsDanger">
						<Select :placeholder="$tt('是否为警告操作')" v-model="modalInfo.IsDanger">
							<Option :value='0'>{{$tt('否')}}</Option>
							<Option :value='1'>{{$tt('是')}}</Option>

						</Select>
					</FormItem>
					</Col>
					<Col span=12>

					<FormItem :label="$tt('排序')" prop="Sort">

						<Select :disabled="modal.canInput" :placeholder="$tt('排序')" v-model="modalInfo.Sort">

							<Input :disabled="modal.canInput" v-model="modalInfo.Sort" :placeholder="$tt('排序')"></Input>

						</Select>
					</FormItem>
					</Col>

				</Row>


				<!-- <Row>
					<Col span=12>
					<FormItem :label="$tt('建档人')" prop="Creator">
						<Input :disabled='true' v-model="modalInfo.Creator" :placeholder="$tt('建档人')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('建档时间')" prop="CreateTime">
						<Input :disabled='true' v-model="modalInfo.CreateTime" :placeholder="$tt('建档时间')"></Input>
					</FormItem>
					</Col>
				</Row> -->

				<!-- <Row>
					<Col span=12>
					<FormItem :label="$tt('修改人')" prop="Modifier">
						<Input :disabled='true' v-model="modalInfo.Modifier" :placeholder="$tt('修改人')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$tt('修改时间')" prop="ModifyTime">
						<Input :disabled='true' v-model="modalInfo.ModifyTime" :placeholder="$tt('修改时间')"></Input>
					</FormItem>
					</Col>
				</Row> -->



				<Row :gutter="24">
					<Col span=24>
					<FormItem :label="$tt('维修图片')" prop="StationCode">
						<div class="demo-upload-list" :key="item.uid" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" :headers="upHeader" :show-upload-list="false"
							:default-file-list="defaultList" :on-success="handleSuccess" name="UpFile"
							:format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
							:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag"
							:action="uploadImageUrl" style="display: inline-block;width:58px;">
							<div style="width: 58px;height:58px;line-height: 58px;">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
						<Modal title="View Image" v-model="visible">
							<img :src="imgName" v-if="visible" style="width: 100%">
						</Modal>
					</FormItem>
				
					</Col>
				</Row>






			</Form>

			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{$tt('取消')}}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{$tt('添加')}}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{$tt('取消')}}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{$tt('修改')}}</Button>
			</div>

		</Modal>




	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {


		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$tt('输入运营商Id')));
				} else {
					if (this.modalInfo.OperatorId.length !== 9) {

						callback(new Error(this.$tt('输入社会信用代码码第9~倒数第2位')));
					}
					callback();
				}
			};
			return {
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				modal: {
					Title: this.$tt('用户添加'),
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					// Id
					// 控件名称
					// 显示名
					// 控件描述
					// 控件图标
					// 是否删除
					// 控件类型
					// 是否为警告操作
					// 排序

					"Id": 0,
					"Name": "",
					"Display": "",
					"Desc": "",
					"Icon": "fas fa-search",
					"IsDeleted": 0,
					"WidgetType": 0,
					"Sort": 1,
					"IsDanger": 0,

					"ModifyBy": -2,
					"ModifyTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),


				},
				zindex: 2000,



				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存，实际点击保存才删除
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],

				/******分割线********/



				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],

					Name: [{
						required: true,
						message: this.$tt('控件名称'),
						trigger: 'blur'
					}],
					Display: [{
						required: true,
						message: this.$tt('显示名称'),
						trigger: 'blur'

					}],
					Icon: [{
						required: true,
						message: this.$tt('图标'),
						trigger: 'blur',

					}],

				},
			};
		},

		methods: {
			//打开新增会员


			show: function(type, params) {
				const _this = this;

				if (type == "add") {
					_this.modal.Title = this.$tt('控件添加');
					_this.modal.type = "add";
					_this.$refs.refForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = this.$tt('控件修改');
					_this.modal.type = "up";

					console.log(params)
					_this.modalInfo = {

						Id: params.Id,
						Name: params.Name,
						Display: params.Display,
						Desc: params.Desc,
						Icon: params.Icon,
						IsDeleted: params.IsDeleted,
						WidgetType: params.WidgetType,
						IsDanger: params.IsDanger,
						Sort: params.Sort,

					};
				}
				_this.modal.ifShow = true

			},


			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;

					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {

				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("控件" + type + "----" + valid)
					if (valid) {
						let parms = _this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/System/AddSysWidget", parms, {}).then(res => {
							console.log("新增会员")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(this.$tt('添加成功'));
								_this.$emit('handleSubmit');
								_this.modalOk("cancle")
							} else {
								this.$Message.success(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})





			},


			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')

				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)

				}

				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})


				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})


			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);

					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)

					this.PictureDelCache.push(file.name)

				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$tt('格式错误'),
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$tt('图片太大'),
					desc: '文件' + file.name + this.$tt(' 图片太大请选择小于 2M.')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},

			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}


		},
		
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}

	}
</script>

<style>
</style>
